// External
import React from 'react';

// Internal
import { AppContent } from 'features/layout';
import SignatureContainer from 'features/recordSignature';


function Dashboard(): JSX.Element {
  return (
    <AppContent sidebarTitle="Assinatura Digital">
      <SignatureContainer />
    </AppContent>
  );
}

export default Dashboard;
